export class PatientSends {

    constructor() {
        this.message = null;
        this.matter = null;
        this.email = null;
        this.phone = null;
        this.listServicesString = null;
    }

    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unauthenticated!`);
            case 404:
                throw new Error(`${response.status} - Not Found!`);
            default:
                break;
        }
    }

    async sendSMS() {
        let datos = null;
        if (this.message != null || this.message.phone != null) {
            let messageSend = JSON.parse(sessionStorage.getItem('clinica')).nombre + "-" + this.message;
            let caracteres = messageSend.toString().length;
            if (caracteres < 465)
            {
                let dataSend = JSON.stringify({
                    mensaje: messageSend,
                    telefono: this.phone
                });
                await fetch(`${process.env.REACT_APP_PUBLIC_URL}parametrizacion-sms/enviar-mensaje`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                    },
                    body: dataSend
                }).then(response => {
                    this.checkStatus(response);
                    return response.json();
                }).then(data => {
                    datos = data;
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
        return datos;
    }

    async sendEmail() {
        let datos = null;
        if (this.message != null || this.message.phone != null) {
            let dataSend = JSON.stringify({
                mensaje: this.message,
                email: this.email,
                asunto: this.matter,
                servicios: this.listServicesString
            });
            await fetch(`${process.env.REACT_APP_PUBLIC_URL}parametrizacion-correo/send-mensaje`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: dataSend
            }).then(response => {
                this.checkStatus(response);
                return response.json();
            }).then(data => {
                datos = data;
            }).catch((error) => {
                console.log(error);
            });
        }
        return datos;
    }

}